export type { YardAreaDetails } from './yardAreaPresenterShared';

export { useYardAreaFetcher } from './useYardAreaFetcher';
export type { UseYardAreaFetcherOptions } from './useYardAreaFetcher';
export type { UseYardAreaFetcherOptions as UseYardAreaPresenterOptions } from './useYardAreaFetcher';

export { useYardAreaDisplay } from './useYardAreaDisplay';
export type {
  YardAreaDisplayField,
  YardAreaDisplayData,
  UseYardAreaDisplayOptions
} from './useYardAreaDisplay';

import { useYardAreaFetcher } from './useYardAreaFetcher';

import type { UseYardAreaFetcherOptions } from './useYardAreaFetcher';

/**
 * Combined fetch + live-update composable. Delegates to {@link useYardAreaFetcher}.
 * Pair with {@link useYardAreaDisplay} when fetch is owned by a parent (e.g. list row).
 */
export function useYardAreaPresenter(options: UseYardAreaFetcherOptions) {
  return useYardAreaFetcher(options);
}
